import React, { useState, useEffect } from 'react'

import { Button, Dialog, Grid, Icon, Typography, Select, Switch, FormHelperText } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';
import useStyles from "./styles";
import { Label, DraggableComponent } from '../../../../../components/UiElements/UiElements';
import { SelectField, InputBaseField, TextareaField } from '../../../../../components/InputField/InputField';
import DialogLoader from './../../../../../components/Loader/DialogLoader';
import { GetUserInfo } from '../../../../../Services/GetUserInfo';
import { PostDataAPI } from '../../../../../Services/APIService';
import { withSnackbar } from "./../../../../../components/Message/Alert";
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import { validateEmail, handleNumberKeyPress, isDigitsOnly, formateMdnNumber, validatePhoneNumber } from '../../../../../../src/components/Common/Extensions';

function AddNewAgency({ dialogOpenClose, handleClose, handleSuccessClose, selectedAgencyId, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [isLoading, setIsLoading] = useState(false);

    const [state, setState] = useState(false);
    const [errorMessages, setErrorMessages] = useState({});

    const handleChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const handleSelectChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const handlePhoneChange = e => {
        const { name, value } = e.target;
        if (e.nativeEvent.data != "e") {

            if (e.nativeEvent.data != null || e.target.value != "") {
                // for fomatting
                const re = /^[0-9\b]+$/;
                e.target.value = e.target.value.replace(' ', '').replace('(', '').replace(')', '').replace('-', '');
                const { name, value } = e.target;
                if ((e.target.value === '' || re.test(e.target.value))) {

                    var cleaned = ('' + e.target.value).replace(/\D/g, '')
                    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
                    if (match) {
                        var intlCode = (match[1] ? '+1 ' : ''),
                            number = [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');

                        setState(prevState => ({
                            ...prevState,
                            [name]: number
                        }));
                        return;
                    }
                    setState(prevState => ({
                        ...prevState,
                        [name]: value
                    }));
                }
                else {
                    if (!re.test(e.target.value)) {
                        e.preventDefault();
                    }

                }
            }
            else {
                setState(prevState => ({
                    ...prevState,
                    [name]: value
                }));

                if (e.target.value != "") {

                    setErrorMessages(prevState => ({
                        ...prevState,
                        errorPhoneLength: true
                    }));
                }

            }
        }
        else
            e.preventDefault();
    }
    const Validate = (errorList) => {
        if (!state.agencyType) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAgencyType: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAgencyType: false
            }));
        }
        if (!state.agencyName) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAgencyName: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAgencyName: false
            }));
        }
        if (!state.email) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmailAddress: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmailAddress: false
            }));
        }
        if (state.email && !validateEmail(state.email)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorValidEmail: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorValidEmail: false
            }));
        }

        if (!state.phone) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhoneNumber: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhoneNumber: false
            }));
        }
        if (state.phone && !validatePhoneNumber(state.phone)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidPhone: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidPhone: false
            }));
        }

        if (isNotificationsChanged && agencyMembers && agencyMembers.length > 0) {
            const hasTitleError = agencyMembers.some((t) => !t.isDeleted && !t.memberTitle);
            const hasNameError = agencyMembers.some((t) => !t.isDeleted && !t.memberName);
            const hasEmailError = agencyMembers.some((t) => !t.isDeleted && (!t.memberEmail || !validateEmail(t.memberEmail)));
            //const hasPhoneError = agencyMembers.some((t) => !t.isDeleted && (!t.memberPhone || !validatePhoneNumber(t.memberPhone)));

            if (hasTitleError) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorMemberTitle: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorMemberTitle: false
                }));
            }

            if (hasNameError) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorMemberName: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorMemberName: false
                }));
            }

            if (hasEmailError) {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorMemberEmail: true
                }));
                errorList.push(true);
            }
            else {
                setErrorMessages(prevState => ({
                    ...prevState,
                    errorMemberEmail: false
                }));
            }
        }

    }

    const [agencyType, setAgencyType] = useState([]);
    const defaultMemberList = [{ memberId: 0, memberName: '', memberEmail: '', memberPhone: '', isDeleted: false },
        { memberId: 0, memberName: '', memberEmail: '', memberPhone: '', isDeleted: false }
    ];
    const [agencyMembers, setAgencyMembers] = useState(defaultMemberList);
    const handleAddNotificationItem = () => {
        var listCount = agencyMembers.filter(t => !t.isDeleted).length;
        if (listCount == 15) {
            showMessage("Error", "A maximum of 15 poeple can be added", "error", 3000);
        } else {
            var newObj = { memberId: 0, memberName: '', memberEmail: '', memberPhone: '', isDeleted: false };
            setAgencyMembers([...agencyMembers, newObj]);
        }

    };

    const handleDeleteNotificationItem = (item, index) => {
        if (item.memberId <= 0) {
            const notificationItems = [...agencyMembers];
            notificationItems.splice(index, 1);
            setAgencyMembers(notificationItems);
        } else {
            const updatedArray = agencyMembers.map((obj, i) => {
                if (obj.memberId === item.memberId) {
                    return { ...obj, isDeleted: true };
                }
                return obj;
            });
            setAgencyMembers(updatedArray);
            setIsNotificationsChanged(true);
        }
    };
    const [isNotificationsChanged, setIsNotificationsChanged] = useState(false);
    const handleNotificationInputChange = (e, index) => {
        const { name, value } = e.target;
        const newInputs = [...agencyMembers];
        newInputs[index][name] = value;
        setAgencyMembers(newInputs);
        setIsNotificationsChanged(true);
    };


    const addAgency = () => {
        let errorList = [];
        Validate(errorList);
        if (errorList.length < 1) {
            
            var method = "fdnagency/addAgency";
            if (selectedAgencyId > 0)
                method = "fdnagency/update";

            state.agencyName = state.agencyName.trim();
            state.email = state.email.trim();
            state.phone = state.phone.trim();
            state.agencyCategory = "LOS";     
            if (isNotificationsChanged && agencyMembers && agencyMembers.length > 0) {
                state.agencyMembers = agencyMembers;
                var matchingMember = agencyMembers.find(item => item.memberEmail == state.email);
                if (matchingMember) {
                    showMessage("Error", "Agency email and member email can't be the same", "error", 3000);
                    return;
                }
            }
            setIsLoading(true);
            PostDataAPI(method, state, true).then((result) => {
                setIsLoading(false)
                if (result.success && result.data) {
                    var message = "Agency added successfully";
                    if (selectedAgencyId > 0)
                        message = "Agency updated successfully";
                    handleSuccessClose(message);
                } else {
                    showMessage("Error", result.message, "error", 3000);
                }
            })
        }

    }
    const loadAgency = () => {
        setIsLoading(true);
        PostDataAPI("fdnagency/get", selectedAgencyId).then((result) => {
            debugger;
            if (result.success && result.data) {
               
                setState(result.data);
                setAgencyMembers(result.data.agencyMembers);
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);
        });
    }

    const loadAgencyType = () => {
        var params = {
            code: "get_agency_type_list",
            parameters: ['']
        };

        PostDataAPI("ddl/loadItems", params).then((result) => {
            if (result.success && result.data != null) {
                setAgencyType(prevState => [...prevState, { value: '', label: 'Select Agency Type' }]);
                result.data.map((item, i) => {
                    setAgencyType(prevState => [...prevState, { value: item.t2, label: item.t3 }]);
                })
            }
        })
    }
    useEffect(() => {
        loadAgencyType();
        if (selectedAgencyId && selectedAgencyId > 0)
            loadAgency();
    }, []);


    return (
        <>

            <Dialog
                classes={{ paper: classes.dialogPaper }}
                disableEscapeKeyDown
                open={dialogOpenClose}
                maxWidth="md"
                PaperComponent={DraggableComponent}
                {...props} >
                <div className={classes.activeDialogContent}>
                    <div className={classes.box}>
                        <div className={classes.header} id="draggable-dialog-title">
                            <Typography className={classes.title}>{selectedAgencyId && selectedAgencyId > 0 ? "Edit Agency" : "Add New Agency"}</Typography>
                            <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                        </div>
                        {isLoading ? <DialogLoader></DialogLoader> : ''}

                        <div className={classes.content}>
                            <Grid container spacing={2}>
                                <Grid lg={6} md={6} xs={12} sm={12} className={classes.paddingLeftRight} >
                                    <Grid row >
                                        <Label item title="Type" size={12} mandatory={true} />
                                        <Grid lg={12} md={12} sm={12}>
                                            <SelectField
                                                options={agencyType}
                                                onChange={handleChange}
                                                placeholder="Agency Type"
                                                name="agencyType"
                                                value={state.agencyType} />

                                            {errorMessages.errorAgencyType && !state.agencyType ? (<FormHelperText style={{ color: "red" }} >
                                                Please select agency type
                                            </FormHelperText>) : ('')}
                                        </Grid>
                                    </Grid>

                                </Grid>
                                <Grid lg={6} md={6} xs={12} sm={12} className={classes.paddingLeftRight} >
                                    <Grid row >
                                        <Label item title="Name" size={12} mandatory={true} />
                                        <Grid lg={12} md={12} sm={12}>
                                            <InputBaseField
                                                name="agencyName"
                                                type="text"
                                                placeholder="Name"
                                                MaxLength="50"
                                                value={state.agencyName}
                                                onChange={handleChange}
                                            />
                                            {errorMessages.errorAgencyName && !state.agencyName ? (<FormHelperText style={{ color: "red" }} >
                                                Please enter agency name
                                            </FormHelperText>) : ('')}
                                        </Grid>
                                    </Grid>

                                </Grid>

                                <Grid lg={6} md={6} xs={12} sm={12} className={classes.paddingLeftRight} >
                                    <Grid row >
                                        <Label item title="Email Address" size={12} mandatory={true} />
                                        <Grid lg={12} md={12} sm={12}>
                                            <InputBaseField
                                                name="email"
                                                type="text"
                                                placeholder="Email Address"
                                                MaxLength="50"
                                                value={state.email}
                                                onChange={handleChange}
                                            />
                                            {errorMessages.errorEmailAddress && !state.email ? (<FormHelperText style={{ color: "red" }} >
                                                Please enter email address
                                            </FormHelperText>) : ('')}
                                            {errorMessages.errorValidEmail && (state.email && !validateEmail(state.email)) ? (<FormHelperText style={{ color: "red" }} >
                                                Please enter a valid email address
                                            </FormHelperText>) : ('')}
                                        </Grid>
                                    </Grid>

                                </Grid>

                                <Grid lg={6} md={6} xs={12} sm={12} className={classes.paddingLeftRight} >
                                    <Grid row >
                                        <Label item title="Phone #" size={12} mandatory={true} />
                                        <Grid lg={12} md={12} sm={12}>
                                            <InputBaseField
                                                name="phone"
                                                type="text"
                                                placeholder="Phone #"
                                                MaxLength={14}
                                                value={formateMdnNumber(state.phone)}
                                                onChange={handlePhoneChange}
                                            />
                                            {errorMessages.errorPhoneNumber && !state.phone ? (<FormHelperText style={{ color: "red" }} >
                                                Please enter phone #
                                            </FormHelperText>) : ('')}
                                            {errorMessages.errorInvalidPhone && state.phone && !validatePhoneNumber(state.phone) ? (<FormHelperText style={{ color: "red" }} >
                                                Please enter valid phone #
                                            </FormHelperText>) : ('')}
                                        </Grid>
                                    </Grid>

                                </Grid>

                                <Grid row container className={classes.headform}>
                                    <Grid xl={8} md={8} sm={8} lg={8}>
                                        <h1> Want notification to more people?
                                            <span className={classes.addNotification} onClick={handleAddNotificationItem}> <AddCircleOutlineIcon style={{ marginRight: '5px' }} />Add </span></h1>
                                    </Grid>
                                    <Grid xl={4} md={4} sm={4} lg={4} className={classes.paddingLeftRight}>
                                    </Grid>
                                    {/*<Grid xl={6} md={6} sm={6} lg={6} className={classes.paddingLeftRight}>*/}
                                    {/*    <Button className={classes.backBtn} onClick = {handleAddressBookClick}> <AddCircleOutlineIcon style={{ marginRight: '5px' }} /> Address book</Button>*/}
                                    {/*</Grid>*/}
                                </Grid>
                                {agencyMembers?.filter(t => !t.isDeleted).map((item, index) => (
                                    <Grid row container>
                                        <Grid xl={6} md={6} sm={6} lg={6} className={classes.paddingLeftRight}>
                                            <Grid row container>
                                            <Grid xl={6} md={6} sm={6} lg={6} className={classes.Leftcol}>
                                                    {index === 0 ?
                                                        <Label title="Title" size={12} /> : ''}
                                                    <Grid xl={12} md={12} sm={12} lg={12}>
                                                        <InputBaseField
                                                            id="memberTitle"
                                                            name="memberTitle"
                                                            type="text"
                                                            value={item.memberTitle}
                                                            placeholder='Title'
                                                            MaxLength='100'
                                                            onChange={(event) => { handleNotificationInputChange(event, index) }}
                                                        />
                                                        {errorMessages.errorMemberTitle && !item.memberTitle ?
                                                            (<FormHelperText style={{ color: "red" }} >
                                                                Please enter title
                                                            </FormHelperText>) : ('')}
                                                    </Grid>
                                                </Grid>
                                                <Grid xl={6} md={6} sm={6} lg={6} className={classes.Leftcol}>
                                                    {index === 0 ?
                                                        <Label title="Full Name" size={12}  /> : ''}
                                                    <Grid xl={12} md={12} sm={12} lg={12}>
                                                        <InputBaseField
                                                            id="memberName"
                                                            name="memberName"
                                                            type="text"
                                                            value={item.memberName}
                                                            placeholder='Full Name'
                                                            MaxLength='100'
                                                            onChange={(event) => { handleNotificationInputChange(event, index) }}
                                                        />
                                                        {errorMessages.errorMemberName && !item.memberName ?
                                                            (<FormHelperText style={{ color: "red" }} >
                                                                Please enter name
                                                            </FormHelperText>) : ('')}
                                                    </Grid>
                                                </Grid>

                                               
                                            </Grid>
                                        </Grid>

                                        <Grid xl={6} md={6} sm={6} lg={6} className={classes.paddingLeftRight}>
                                            {index === 0 ? <Label title="Email Address" size={12} /> : ''}
                                            <Grid container xl={12} md={12} sm={12} lg={12}>
                                                <Grid item xl={8} md={8} sm={8} lg={8}>
                                                    <InputBaseField
                                                        id="memberEmail"
                                                        name="memberEmail"
                                                        type="email"
                                                        value={item.memberEmail}
                                                        placeholder='Email Address'
                                                        MaxLength='100'
                                                        onChange={(event) => { handleNotificationInputChange(event, index) }}
                                                    />
                                                    {errorMessages.errorMemberEmail &&
                                                        (!item.memberEmail || !validateEmail(item.memberEmail)) ?
                                                        (<FormHelperText style={{ color: "red" }} >
                                                            Please enter a valid email address
                                                        </FormHelperText>) : ('')}
                                                </Grid>
                                                <Grid item xl={4} md={4} sm={4} lg={4} style={{ padding: '6px',marginTop:'5px' }}>
                                                    {/*<Button className={classes.deleteBtn} onClick={() => { handleDeleteNotificationItem(item, index) }}>Delete</Button>*/}
                                                    <span onClick={() => { handleDeleteNotificationItem(item, index) }}><CloseIcon /></span>
                                                </Grid>
                                            </Grid>

                                        </Grid>

                                    </Grid>
                                ))
                                }

                            </Grid>
                        </div>

                        <div className={classes.footer}>
                            <div className={classes.footerRight}>
                                <Button className={classes.backBtn} onClick={handleClose}>Cancel</Button>
                                <Button className={classes.changeBtn}
                                    onClick={addAgency}
                                >Save</Button>
                            </div>
                        </div>

                    </div>
                </div>
            </Dialog >
        </>
    )
}

export default withSnackbar(AddNewAgency); 